import React from 'react';
import { pick } from 'ramda';
import { DateTime } from 'luxon';
import { useTranslations } from 'js/hooks/i18n';
import { useUserSelector } from 'js/store/hooks';
import { componentService } from 'js/services/component.service';

export const LastLoginDate = ({ format = 'yyyy-MM-dd HH:mm:ss' }) => {
    const t = useTranslations();
    const { isLoggedIn, previousLoginTime } = useUserSelector(pick(['isLoggedIn', 'previousLoginTime']));

    if (!isLoggedIn) {
        return null;
    }

    if (!previousLoginTime) {
        return <span>{t('playtech.mobile.system.LastLoginDate.noPreviousLogin')}</span>;
    }

    return (
        <span>
            {DateTime.fromFormat(previousLoginTime, 'yyyy-LL-dd HH:mm:ss.SSS', { zone: 'utc' })
                .toLocal()
                .toFormat(format)}
        </span>
    );
};

componentService.registerWebContentComponents({ LastLoginDate });
